import {QUIKLEARN_BACKEND_URL} from 'config/app.config';
import {getWebAccessToken} from './webAuthSession';

export const validateWebLaunchToken = async launchToken => {
  const accessToken = getWebAccessToken();
  if (!accessToken || !launchToken) {
    throw new Error('Your web learning session has expired. Please reopen the course.');
  }
  const response = await fetch(
    `${String(QUIKLEARN_BACKEND_URL).replace(/\/$/, '')}/api/auth/token/validate-metaverse-token`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify({token: launchToken}),
    },
  );
  if (!response.ok) throw new Error('Your web learning session is invalid or expired.');
  const payload = await response.json();
  if (!payload?.claims || payload.claims.userId !== payload.claims.sub) {
    throw new Error('The verified web learning session is incomplete.');
  }
  const claims = payload.claims;
  const roomId = Array.isArray(claims.aud) ? claims.aud[0] : claims.aud;
  if (!claims.sub || !roomId || !claims.iss || !Array.isArray(claims.permissions)) {
    throw new Error('The verified web learning session is incomplete.');
  }
  return {
    ...claims,
    peerId: claims.sub,
    roomId,
    integration: claims.iss,
  };
};
